import { render, staticRenderFns } from "./AppPartnerSites.vue?vue&type=template&id=2a698dfa&scoped=true&"
import script from "./AppPartnerSites.vue?vue&type=script&lang=js&"
export * from "./AppPartnerSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a698dfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VExpandXTransition,VIcon,VSlideXReverseTransition})
